export const DocumentLocks = {
	EDITION: "EDITION",
	EXCLUSION: "EXCLUSION",
	OVERRIDE: "OVERRIDE"
};

export default DocumentLocks;
